import { render, staticRenderFns } from "./RecordDot.vue?vue&type=template&id=3e1210e0&functional=true&"
import script from "./RecordDot.vue?vue&type=script&lang=js&"
export * from "./RecordDot.vue?vue&type=script&lang=js&"
import style0 from "./RecordDot.vue?vue&type=style&index=0&id=3e1210e0&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  null
  
)

export default component.exports